export enum BarcodeKinds {
  Qr = 1,
  QrSequencial = 2,
  Code128 = 3,
  Nw7 = 4,
}
